import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ImageLogo = () => (
  <StaticQuery
    query={graphql`
      query {
        file(
          relativePath: {
            regex: "/assets/logo-longmakeup/LongMakeup-logo-black-star-only/"
          }
        ) {
          id
          name
          ext
          size
          childImageSharp {
            gatsbyImageData(
           width: 640
           placeholder: BLURRED
           breakpoints:	[200, 340, 520, 890]
           formats: [AUTO, WEBP]
         )

          }
        }
      }
    `}
      render={(data) => {
        const image = getImage(data.file)
        return(
          <GatsbyImage
          style={{
            width: '30%',
            margin: '0 auto',
            display: 'block',
            marginTop: '14px',
            marginBottom: '14px',
          }}
          image={image}
          alt={'example image'}
        />

        )
      }}
  />
)
export default ImageLogo
